import { render, staticRenderFns } from "./Sorteio.vue?vue&type=template&id=40bea616"
import script from "./Sorteio.vue?vue&type=script&lang=js"
export * from "./Sorteio.vue?vue&type=script&lang=js"
import style0 from "./Sorteio.vue?vue&type=style&index=0&id=40bea616&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports